
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[donate]/[id]",
      function () {
        return require("private-next-pages/[donate]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[donate]/[id]"])
      });
    }
  